import {React, useEffect, useRef } from 'react';
import Parallax from 'parallax-js';

import 'swiper/swiper-bundle.min.css';

import mentor from "../img/mentor.jpg";
import mentor1 from "../img/mentor1.jpg";
import "./images.css";


export default function Mentor() {
  const sceneRef = useRef(null); // Reference for the container
  
  useEffect(() => {
    if (sceneRef.current) {
        const parallaxInstance = new Parallax(sceneRef.current, {
            relativeInput: true, // Adjusts movement based on mouse or scroll
        });
  
        return () => parallaxInstance.destroy(); // Cleanup on unmount
      }
  }, []);

  return (
    <div>
     <section className="overflow-hidden">
        <div className="container pt-2 pt-sm-4 pb-sm-2 pb-md-4 py-xl-5 mt-5">
          <div className="row align-items-center py-3 mt-md-1 my-lg-2 my-xl-2 my-xxl-3">
            <div className="col-lg-7 order-lg-2 d-flex justify-content-center justify-content-lg-end mb-4 mb-md-5 mb-lg-0 pb-3 pb-md-0">
              <div className="parallax me-lg-n4 me-xl-n5" style={{ maxWidth: '667px' }}>
                <div ref={sceneRef} className="container mt-4">
                  <div className="parallax-container position-relative" data-depth="0.1"><img className="img-fluid custom-image shadow-lg" src={mentor} alt="Rubleva Anna"/></div>
                    <br/>
                    <br/>
                  <div className="parallax-container position-relative" data-depth="0.1"><img className="img-fluid custom-image shadow-lg" src={mentor1} alt="Rubleva Anna"/></div>
                    {/* <div className="parallax-layer" data-depth="0.1"><img src="assets/img/landing/business-consulting/hero/01.png" alt="Layer"/></div> */}
                    {/* <div className="parallax-layer stat-box" data-depth="-0.25"><img src="assets/img/landing/business-consulting/hero/03.png" alt="Layer"/></div> */}
                    {/* <div className="parallax-layer" data-depth="0.25"><img src="assets/img/landing/business-consulting/hero/03.png" alt="Layer"/></div> */}
                  </div>
                </div>
                </div>
                <div className="col-lg-5 order-lg-0">
                  <h2 className="display-6 text-center text-lg-start pb-sm-2 pb-md-3">Наставничество.</h2>
                  <h2 className="lead text-center text-lg-start pb-xl-2 mx-auto mx-lg-0 mb-5" style={{ maxWidth: '620px' }}>Для систематизации и масштабирования деятельности компании.</h2>
                  <ul className="list-unstyled fs-lg text-center text-lg-start pb-1 mx-auto mx-lg-0 mb-3" style={{ maxWidth: '620px' }}>
                    {/* <p className="h4">Коуч-сессии позволяют проработать:</p> */}
                    <li className="mb-2">✔️ Работа над текущей бизнес-моделью (систематизация бизнес-ролей, настройка KPI, рекомендации по инструкциям и регламентам, анализ мотивации и вовлеченности сотрудников)</li>
                    <li className="mb-2">✔️ Работа с бизнес-моделью будущего (постановка смелой и глобальной цели, формулировка миссии, составление прогнозов развития бизнеса)</li>
                    <li className="mb-2">✔️ Работа по выбору и адаптации персонала (описание бизнес-ролей, рекомендации по быстрой адаптации сотрудника, тестирование кандидатов, анализ профиля, мотивации и прогноз вовлеченности сотрудника)</li>
                    <br/>
                    <p className="lead fs-xl text-center text-lg-start">Задача - получать удовольствие от развития бизнеса и собственного развития.</p>
                  {/* <div className="input-group mx-auto mx-lg-0" style={{maxWidth: '420px'}}><span className="input-group-text text-muted"><i className="ai-mail"></i></span>
                    <input className="form-control" type="email" placeholder="Enter your email" />
                    <button className="btn btn-primary" type="button">Book a call</button>
                  </div> */}
                  <br/>
                  <p  className="lead fs-lg">Продолжительность: от 1 месяца- 6 месяцев</p>
                  {/* <p className="mb-lg-3 fw-semibold">Рекомендуется 4-6 продвинутых сессий.</p> */}
                  <p  className="lead fs-lg">Стоимость: от 100 000 рублей до 500 000 рублей.</p>
                   <a className="nav-link fs-lg position-relative mb-2 " href="tel:+7(922)471-44-34"><strong>По всем интересующим вопросам можно обратиться: <br/> + 7(922)471-44-34, +7(992)300-65-46</strong></a>
                   <br/>   
                  </ul>
                </div>
          </div>
          <div className="container">
              <p className="m-1 position-relative text-center zindex-2 fw-bold h4"> Подробности о направлении и наличие мест уточняйте у администратора
              </p>
             <p className="fs-lg mb-2">Наши контакты:  
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://vk.com/rubleva_coach"><i className="ai-vk"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://www.instagram.com/anyuta_rubleva"><i className="ai-instagram"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://t.me@AnnaRubleva_coach"><i className="ai-telegram"> </i> </a>
              <a className="nav-link fs-lg position-relative mb-2" href="mailto:developskillsnow@yandex.ru">Email: developskillsnow@yandex.ru</a>
             </p>
          </div>
          <div className="d-lg-none mt-3 p-1"> <p></p></div>
          </div>
          </section>
          {/* <section className="mb-5 py-5">
      <div className="container">
        <h2 className="text-center">Мотивация</h2>
        <p className="text-center">
          Мы поможем вам преодолеть barrier и достичь своих целей.
        </p>
      </div>
     <div className="container py-5">
      <h1 className="display-5 fw-bold text-center mb-4">Our Team</h1>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
         <div className="col">
          <div className="card h-100">
            <img src="assets/img/landing/corporate/team/1.jpg" className="card-img-top" alt="Team Member 1" />
             <div className="card-body">
              <h5 className="card-title">John Doe</h5>
               <p className="card-text">Founder &amp; CEO</p>
             </div>
           </div>
         </div>
         <div className="col">
           <div className="card h-100">
             <img src="assets/img/landing/corporate/team/2.jpg" className="card-img-top" alt="Team Member 2" />
             <div className="card-body">
              <h5 className="card-title">Jane Doe</h5>
               <p className="card-text">Co-Founder &amp; CTO</p>
             </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
           <img src="assets/img/landing/corporate/team/3.jpg" className="card-img-top" alt="Team Member 3" />
             <div className="card-body">
               <h5 className="card-title">Bob Smith</h5>
             <p className="card-text">Software Engineer</p>
             </div>
           </div>
         </div>
      </div>
     </div>
    </section> */}
        </div>
    
  );
}
